// src/components/Header.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { signOutUser } from '../services/authService';
import '../styles/components/Header.scss'; // スタイルを追加

const Header = () => {
    const { currentUser, accountId } = useAuth();

    const handleLogout = async () => {
        await signOutUser();
    };

    return (
        <header className="app-header">
            <div className="header-left">
                <Link to={`/dashboard/${accountId}`} className="app-title">Suisui</Link>
            </div>
            <nav className="header-nav">
                <ul>
                    <li><Link to={`/dashboard/${accountId}`}>ダッシュボード</Link></li>
                    <li><Link to={`/pages/${accountId}`}>ページ一覧</Link></li>
                    <li><Link to={`/common-parts/${accountId}`}>共通パーツ</Link></li>
                    <li><Link to={`/media/${accountId}`}>メディア</Link></li>
                    <li><Link to={`/settings/${accountId}`}>設定</Link></li>
                    <li><Link to={`/users/${accountId}`}>ユーザー管理</Link></li>
                    {currentUser && (
                        <li>
                            <button onClick={handleLogout} className="logout-button">ログアウト</button>
                        </li>
                    )}
                </ul>
            </nav>
        </header>
    );
};

export default Header;